import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { SearchState } from "./search-state.model";

@Injectable({
  providedIn: 'root'
})
export abstract class ISearchService {

  public abstract searchStateGet(): SearchState;

  public abstract searchStateChangedGet(): Observable<SearchState>;

  public abstract searchStateSet(searchState: SearchState, doNavigation: boolean): void;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ISearchServiceToken = new InjectionToken<ISearchService>('ISearchServiceToken');
